import { render } from "./LanguageFlag.vue?vue&type=template&id=3c2b4ee0&scoped=true"
import script from "./LanguageFlag.vue?vue&type=script&lang=js"
export * from "./LanguageFlag.vue?vue&type=script&lang=js"

import "./LanguageFlag.vue?vue&type=style&index=0&id=3c2b4ee0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c2b4ee0"]])

export default __exports__